import script from "./AppInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppInput.vue?vue&type=script&setup=true&lang=ts"

import "./AppInput.vue?vue&type=style&index=0&id=455a7b9a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-455a7b9a"]])

export default __exports__